import Toast from '../constants/constants';
import ApiCalls from '../classes/ApiCalls';
import store from '../state/store/Store';

export class DelegateRepository
{
    create()
    {
        backdrop.show('Creating delegate...Please wait!');
        let form = $('#create-delegate-form');
        let formData = new FormData();
        let delegatePicture = store.getState().fileUpload.data?.passportPictureBlobFile ?? null;
        formData.append('serial', form.serialize());
        formData.append('delegatePicture', delegatePicture);

        let extraAjaxOptions = {
            processData: false,
            contentType: false,
            async: false,
            cache: false,
        }

        let success = function(response){
            backdrop.hide();
            Toast.fire({
                icon: response.type,
                title: response.title
            });
            form.find('input, select, textarea').val('')
        }
        let errorMessage = 'Failed to enroll new delegate. Please check your connection and try again or contact your System Administrator';

        new ApiCalls(formData, form.attr('action'), success, errorMessage, extraAjaxOptions).dispatch()
    }
}
